import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

import { CreateTwoTone, DeleteOutlineRounded } from "@material-ui/icons";
import ValidationPlanningService from "../../../services/ValidationPlanningService";
import ConfirmationDialog from "../../tools/ConfirmationDialog";
import Message from "../../tools/Message";
import Switch from "@mui/material/Switch";
import { DataGrid } from "@material-ui/data-grid";
import moment from "moment";
import { escapeRegExp } from "../../../utils";
import LoadingSimpleBackdrop from "../../tools/LoadingSimpleBackdrop";
import { useNavigate } from 'react-router-dom';
import PlanningService from "../../../services/PlanningService";

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
}));
const label = { inputProps: { "aria-label": "Switch demo" } };

export default function ValidationSettingTable() {
  const navigate = useNavigate();
  const [checked, setChecked] = React.useState(false);
  const [searchText, setSearchText] = React.useState("");
  const [rows, setRows] = useState([]);
  const [id_to_delete, setId_to_delete] = useState(0);
  const [confirmationDialog, setConfirmationDialog] = React.useState({
    openDialog: false,
    messageDialog: "Voulez vous vraiment supprimer  ?",
  });
  const { openDialog, messageDialog } = confirmationDialog;
  const [message, setMessage] = React.useState({
    open: false,
    color: "green",
    messageInfo: "",
  });
  const { open, color, messageInfo } = message;

  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = React.useState(false);

  function loadTable() {
    setOpenLoadingSimpleBackdrop(true);
    PlanningService.periodelist().then((result) => {
      if (result && result.data) {
        setRows(
          result.data.map((row) => ({
            ...row,
            id: row.periode_id,
          }))
        );
        setOpenLoadingSimpleBackdrop(false);
      }else{
        setOpenLoadingSimpleBackdrop(false);
      }
    });
  }

  useEffect(() => {
    loadTable();
  }, []);

  const handleEdit = (id) => (ev) => {
    navigate("/mission_periode/add/" + id);
  };
  const handleDelete = (id) => (ev) => {
    setId_to_delete(id);
    setConfirmationDialog({ ...confirmationDialog, openDialog: true, messageDialog: "Voulez vous vraiment supprimer?" });
  };
  function closeDialog() {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });
  }
  function confirmDialog() {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });
    ValidationPlanningService.deletePlanningService(id_to_delete)
      .then((result) => {
        if (result.status) {
          loadTable();
          setMessage({
            ...message,
            open: true,
            color: "green",
            messageInfo: result.message,
          });
        } else {
          setMessage({
            ...message,
            open: true,
            color: "red",
            messageInfo: result.message,
          });
        }
      })
      .catch((err) => {
        setMessage({
          ...message,
          open: true,
          color: "red",
          messageInfo: "erreur",
        });
      });
  }

  function cancelDialog() {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });
  }

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }

  const requestSearch = (searchValue) => {
    setSearchText(searchValue);
    const searchRegex = new RegExp(escapeRegExp(searchValue), "i");
    const filteredRows = [...rows].filter((row) => {
      return Object.keys(row).some((field) => {
        return searchRegex.test(row[field].toString());
      });
    });
  };

  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pageCount, setPageCount] = React.useState(0);
  const [rowCount, setRowCount] = React.useState(0);
  const fetchIdRef = React.useRef(0);

  const column = [
    {
      field: "date_debut",
      headerName: "Date de début",
      width: 200,
      valueFormatter: (params) => {
        return `${moment(params.row.date_debut).format('DD/MM/YYYY')}`;
      },
    },
    {
      field: "date_fin",
      headerName: "Date fin",
      width: 200,
      valueFormatter: (params) => {
        return `${moment(params.row.date_fin).format('DD/MM/YYYY')}`;
      },
    },
    {
      field: "date_alerte",
      headerName: "Date d'alerte",
      width: 200,
      valueFormatter: (params) => {
        return `${moment(params.row.date_alerte).format('DD/MM/YYYY')}`;
      },
    },
    { field: "description", headerName: "Description", width: 200 },
    {
      field: "active",
      headerName: "Active",
      width: 200,
      renderCell: (params) => {

        const id = params.row.periode_id;
        const handleSwitchChange = (id) => (event) => {
          PlanningService.activeperiode(id, event.target.checked).then((res) => {
            if (res && res.status) {
              loadTable();
              setMessage({
                ...message,
                open: true,
                color: "green",
                messageInfo: res.message,
              });
            } else {
              setMessage({
                ...message,
                open: true,
                color: "red",
                messageInfo: res.message,
              });
            }
          });
        };
        return (
          <Switch
            checked={params.row.active === "false" ? false : true}
            onChange={handleSwitchChange(params.row.periode_id)}
            inputProps={{ "aria-label": "controlled" }}
            title="Activation"
          />
        );
      }
    },
    {
      field: "Action",
      headerName: "Actions",
      width: 200,
      renderCell: (params) => (
        <span>
          <Button onClick={handleEdit(params.row.periode_id)} title="Modifier ce paramètre">
            <CreateTwoTone style={{ color: "black" }} />
          </Button>


          <Button onClick={handleDelete(params.row.periode_id)} title="Supprimer ce paramètre">
            <DeleteOutlineRounded style={{ color: "red" }} />
          </Button>

        </span>
      ),
    },
  ];


  return (
    <React.Fragment>
      
      <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop}/>
      <div style={{ height: "70vh", width: "100%" }}>
        <DataGrid
          columns={column}
          rows={rows}
          pageSize={7}
          rowsPerPageOptions={[7]}
          disableSelectionOnClick
          componentsProps={{
            toolbar: {
              value: searchText,
              onChange: (event) => requestSearch(event.target.value),
              clearSearch: () => requestSearch(""),
            },
          }}
        />
      </div>

      <ConfirmationDialog
        openDialog={openDialog}
        messageDialog={messageDialog}
        closeDialog={closeDialog}
        confirmDialog={confirmDialog}
        cancelDialog={cancelDialog}
      />
      <Message
        open={open}
        color={color}
        messageInfo={messageInfo}
        handleClose={handleCloseMessage}
      />
    </React.Fragment>
  );
}
